import { CategoryStore } from './CategoryStore';
import { ConfigurationStore } from './ConfigurationStore';
import { LocalizationStore } from './LocalizationStore';
import { MostCommonQuestionsStore } from './MostCommonQuestionsStore';
import { SearchResultStore } from './SearchResultStore';
import type { Configuration } from '~/models/configuration';

export class RootStore {
  readonly configurationStore: ConfigurationStore;
  readonly localizationStore: LocalizationStore;
  readonly categoryStore: CategoryStore;
  readonly mostCommonQuestionsStore: MostCommonQuestionsStore;
  readonly searchResultStore: SearchResultStore;

  constructor(configuration: Configuration) {
    this.configurationStore = new ConfigurationStore(this, configuration);
    this.localizationStore = new LocalizationStore(this);
    this.categoryStore = new CategoryStore(this);
    this.mostCommonQuestionsStore = new MostCommonQuestionsStore(this);
    this.searchResultStore = new SearchResultStore(this);
  }
}
